(function () {
	const header = () => {
		const header = document.querySelector(".shopify-section-header");
		const menu = document.querySelector(".list-menu--inline");
		const menuLinks = document.querySelectorAll(".list-menu-item");
		const search = document.querySelector(".header__search");

		header.addEventListener("keydown", (e) => {
			if (e.code === "Escape" && search.isOpen) {
				search.close();
			}
		});

		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		const annBar = document.querySelector(".section-announcement");
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries;

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					"--ann-height",
					`${entry.intersectionRect.height}px`,
				);
			} else {
				document.documentElement.style.setProperty("--ann-height", `0px`);
			}
		});
		if (annBar) annBarObserver.observe(annBar);

		// Delay para permitir movimiento diagonal sin cerrar el menú al pasar por el logo
		let closeMenuTimer = null;

		const cancelCloseMenu = () => {
			if (closeMenuTimer) {
				clearTimeout(closeMenuTimer);
				closeMenuTimer = null;
			}
		};

		const scheduleCloseMenu = () => {
			cancelCloseMenu();
			closeMenuTimer = setTimeout(() => {
				closeMenuTimer = null;
				menuLinks.forEach((link) => {
					link.classList.remove("list-menu--megamenu-visible");
					link.querySelector(".header__menu-item")?.setAttribute("aria-expanded", "false");
				});
				// Restaurar transparencia al cerrar el menú si el header está en el top (no sticky)
				if (
					header.classList.contains("color-background-1") &&
					!header.classList.contains("shopify-section-header-sticky")
				) {
					header.classList.add("color-background-3");
				}
			}, 200);
		};

		menuLinks.forEach((link) => {
			link.addEventListener("mouseenter", (e) => {
				cancelCloseMenu();
				if (link.classList.contains("list-menu--megamenu")) {
					link.classList.add("list-menu--megamenu-visible");
					link.querySelector(".header__menu-item")?.setAttribute("aria-expanded", "true");
					if (
						header.classList.contains("color-background-3") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.remove("color-background-3");
					}

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove("list-menu--megamenu-visible");
							el.querySelector(".header__menu-item")?.setAttribute("aria-expanded", "false");
						}
					});
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove("list-menu--megamenu-visible");
						el.querySelector(".header__menu-item")?.setAttribute("aria-expanded", "false");
					});
				}
			});
		});
		menu.addEventListener("mouseenter", cancelCloseMenu);
		menu.addEventListener("mouseleave", scheduleCloseMenu);

		document.body.addEventListener('mousedown', function() {
			document.body.classList.add('mouse-focus');
		});

		document.body.addEventListener('keydown', function(e) {
				if (e.key === 'Tab') {
					document.body.classList.remove('mouse-focus');
				}
		});

		const addBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains("color-background-3") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.remove("color-background-3");
					}
				}
			});

			headerObserver.observe(header);
		};

		const removeBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains("color-background-1") &&
						!header.classList.contains("shopify-section-header-sticky") &&
						!header.querySelector(".list-menu--megamenu-visible")
					) {
						header.classList.add("color-background-3");
					}
				}
			});

			headerObserver.observe(header);
		};

		header.addEventListener("mouseenter", addBackground);

		header.addEventListener("focus", addBackground);

		header.addEventListener("focusin", addBackground);

		header.addEventListener("mouseleave", removeBackground);

		header.addEventListener("focusout", removeBackground);

		const megaMenuListLinks = () => {
			const megaMenuLinkWithSubmenu = document.querySelector(
				".mega-menu__list-item--children",
			);
			const megaMenuLinks = document.querySelectorAll(".mega-menu__list-item");
			if (megaMenuLinkWithSubmenu) {
				megaMenuLinks.forEach((link) => {
					link.classList.add("mega-menu__list-item--opacity");
				});
				megaMenuLinkWithSubmenu.classList.remove(
					"mega-menu__list-item--opacity",
				);
				megaMenuLinkWithSubmenu.classList.add("mega-menu__list-item--visible");
			}
			$(".mega-menu__list-item").mouseenter(function (event) {
				if (megaMenuLinkWithSubmenu) {
					megaMenuLinkWithSubmenu.classList.remove(
						"mega-menu__list-item--visible",
					);
				}
				$(this).removeClass("mega-menu__list-item--opacity");
				$(this).siblings().addClass("mega-menu__list-item--opacity");
				$(this).mouseleave(() => {
					$(this).siblings().removeClass("mega-menu__list-item--opacity");
				});
			});
			$(".mega-menu__list-item").focus(function (event) {
				if (megaMenuLinkWithSubmenu) {
					megaMenuLinkWithSubmenu.classList.remove(
						"mega-menu__list-item--visible",
					);
				}
				$(this).removeClass("mega-menu__list-item--opacity");
				$(this).siblings().addClass("mega-menu__list-item--opacity");
				$(this).mouseleave(() => {
					$(this).siblings().removeClass("mega-menu__list-item--opacity");
				});
			});
		};

		const megaMenuSublinks = () => {
			$(".mega-menu--list .mega-menu__submenu-item").mouseenter(function (
				event,
			) {
				$(this).removeClass("mega-menu__submenu-item--opacity");
				$(this)
					.parent()
					.siblings()
					.find(".mega-menu__submenu-item")
					.addClass("mega-menu__submenu-item--opacity");
				$(this).mouseleave(() => {
					$(this)
						.parent()
						.siblings()
						.find(".mega-menu__submenu-item")
						.removeClass("mega-menu__submenu-item--opacity");
				});
			});
			$(".mega-menu--list .mega-menu__submenu-item").focusin(function (event) {
				$(this).removeClass("mega-menu__submenu-item--opacity");
				$(this)
					.parent()
					.siblings()
					.find(".mega-menu__submenu-item")
					.addClass("mega-menu__submenu-item--opacity");
				$(this).focusout(() => {
					$(this)
						.parent()
						.siblings()
						.find(".mega-menu__submenu-item")
						.removeClass("mega-menu__submenu-item--opacity");
				});
			});
		};
		megaMenuListLinks();
		megaMenuSublinks();

		const main = document.querySelector("main");
		const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
		if (
			main
				.querySelectorAll(".shopify-section")[0]?.classList.contains("section--has-overlay") &&
			!main
				.querySelectorAll(".shopify-section")[0]?.classList.contains("not-margin")
		) {
			header.classList.add("color-background-1", "color-background-3");
			if (breadcrumbs) {
				breadcrumbs.classList.add("color-background-3");
			}
		}
	};

	header();

	// ── Mega Tab Sidebar: switch panels (L2→L3) and sub-panels (L3→L4) ────────
	function hideSubpanels(wrapper) {
		wrapper.classList.remove("mega-tab__wrapper--subpanel-active");
		wrapper.querySelectorAll(".mega-tab__subpanel.is-active").forEach((p) => p.classList.remove("is-active"));
		wrapper.querySelectorAll(".mega-tab__link.is-subpanel-active").forEach((el) => el.classList.remove("is-subpanel-active"));
	}

	function initMegaTabSidebars() {
		document.querySelectorAll("[data-mega-tab-sidebar]").forEach((wrapper) => {
			const panelsArea = wrapper.querySelector(".mega-tab__panels");
			const subpanelsArea = wrapper.querySelector(".mega-tab__subpanels");

			wrapper.addEventListener("mouseover", (e) => {
				// ── L2 → L3: sidebar item activa panel ──
				const sidebarItem = e.target.closest(".mega-tab__sidebar [data-panel]");
				if (sidebarItem) {
					const panelId = sidebarItem.dataset.panel;

					wrapper.querySelectorAll(".mega-tab__sidebar-item").forEach((el) => el.classList.remove("is-active"));
					sidebarItem.classList.add("is-active");

					if (panelsArea) {
						panelsArea.querySelectorAll(".mega-tab__panel").forEach((p) => p.classList.remove("is-active"));
						const target = panelsArea.querySelector(`[data-panel-id="${panelId}"]`);
						if (target) target.classList.add("is-active");
					}

					// Al cambiar de panel principal, ocultar sub-paneles
					hideSubpanels(wrapper);
					return;
				}

				// ── L3 → L4: item con hijos activa sub-panel ──
				const subpanelTrigger = e.target.closest(".mega-tab__panel-grid [data-subpanel]");
				if (subpanelTrigger && subpanelsArea) {
					const subpanelId = subpanelTrigger.dataset.subpanel;

					subpanelsArea.querySelectorAll(".mega-tab__subpanel").forEach((p) => p.classList.remove("is-active"));
					const target = subpanelsArea.querySelector(`[data-subpanel-id="${subpanelId}"]`);
					if (target) target.classList.add("is-active");

					wrapper.classList.add("mega-tab__wrapper--subpanel-active");

					// Marcar trigger activo
					const grid = subpanelTrigger.closest(".mega-tab__panel-grid");
					grid?.querySelectorAll("[data-subpanel]").forEach((el) => el.classList.remove("is-subpanel-active"));
					subpanelTrigger.classList.add("is-subpanel-active");
					return;
				}

				// ── L3 item sin hijos → ocultar sub-panel ──
				const regularLink = e.target.closest(".mega-tab__panel-grid .mega-tab__link:not([data-subpanel])");
				if (regularLink) {
					hideSubpanels(wrapper);
				}
			});
		});
	}

	initMegaTabSidebars();
	 document.addEventListener("shopify:block:load", initMegaTabSidebars);

    // ── Reordenar mega-tab grids: flujo vertical por columnas ─────────────────
    const reorderMegaTabGrids = () => {
        document.querySelectorAll('.mega-tab__panel-grid:not(.mega-tab__panel-grid--single)').forEach((grid) => {
            const items = Array.from(grid.children);
            if (items.length === 0) return;

            const cols = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
            const rows = Math.ceil(items.length / cols);

            const reordered = [];
            for (let row = 0; row < rows; row++) {
                for (let col = 0; col < cols; col++) {
                    const index = col * rows + row;
                    if (items[index]) reordered.push(items[index]);
                }
            }

            reordered.forEach((item) => grid.appendChild(item));
        });
    };

    reorderMegaTabGrids();
    document.addEventListener("shopify:section:load", reorderMegaTabGrids);
    document.addEventListener("shopify:block:load", reorderMegaTabGrids);

	// ── Drawer drill-down navigation ──────────────────────────────────────────
	// Problema: onSummaryClick (global.js) se une en fase bubble sobre <summary>.
	// Solución: interceptamos en CAPTURE (antes de bubble) sobre cada summary.
	//   - Click en texto → navegamos al link y detenemos el evento (no abre submenú)
	//   - Click en caret › → no hacemos nada → onSummaryClick abre el submenú
	// Para títulos de cabecera y links de último nivel: stopPropagation + navigate
	// para asegurar navegación ante cualquier handler padre que pudiera interferir.
	// Devuelve true solo si el href es una URL real (no "#" ni vacío)
	function hasRealHref(el) {
		const attr = el.getAttribute("href");
		return attr && attr !== "#";
	}

	function initDrawerNavigation() {
		const drawer = document.querySelector("menu-drawer");
		if (!drawer) return;

		// 1. Split click en summaries: texto → navega (si tiene URL real), caret → abre submenú
		//    Si href="#", dejamos que onSummaryClick abra el submenú (comportamiento correcto
		//    para ítems padre sin URL propia).
		drawer.querySelectorAll("summary.menu-drawer__menu-item").forEach((summary) => {
			summary.addEventListener("click", function (e) {
				if (e.target.closest(".icon-caret")) return; // caret: dejar actuar a onSummaryClick
				const link = this.querySelector(".menu-drawer__menu-link");
				if (link && hasRealHref(link)) {
					e.stopImmediatePropagation(); // impide onSummaryClick (bubble)
					window.location.href = link.href;
				}
				// href="#" → no interceptamos → onSummaryClick abre el submenú
			}, true); // CAPTURE — dispara antes que el bubble de onSummaryClick
		});

		// 2. Títulos de cabecera del submenú → navegación directa (solo si URL real)
		drawer.querySelectorAll(".menu-drawer__submenu-title").forEach((link) => {
			link.addEventListener("click", function (e) {
				e.stopPropagation();
				if (hasRealHref(this)) window.location.href = this.href;
			});
		});

		// 3. Links de último nivel (dentro del submenú, fuera de summary) → navegación directa
		drawer.querySelectorAll(".menu-drawer__submenu a.menu-drawer__menu-item").forEach((link) => {
			link.addEventListener("click", function (e) {
				e.stopPropagation();
				if (hasRealHref(this)) window.location.href = this.href;
			});
		});
	}

	initDrawerNavigation();
	document.addEventListener("shopify:section:load", initDrawerNavigation);
	document.addEventListener("shopify:block:load", initDrawerNavigation);

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();
